import React from 'react'
import PropTypes from 'prop-types'
import { PrismicLink, PrismicRichText } from '@prismicio/react'

const Text = ({ slice }) => {
  return (
    <section className='component-text mx-auto w-full max-w-screen-xl px-4 py-10'>
      <div className='prose prose-lg prose-invert mx-auto'>
        <PrismicRichText field={slice.primary.text.richText} />
      </div>
      {slice.primary.button_link.url != null && (
        <PrismicLink className='button mt-3' field={slice.primary.button_link}>
          {slice.primary.button_text}
        </PrismicLink>
      )}
    </section>
  )
}

Text.propTypes = {
  slice: PropTypes.object.isRequired
}

export default Text
